import { fetchTasksList } from '../api';
import { Env } from '@/shared/config/environment';

const ARCHIVED_TASKS_PER_PAGE_COUNT = 10;

const state = {
  activeFilters: {
    partner: null,
    period: {
      start: null,
      end: null,
    },
  },

  archivedTasksList: null,
  isLoadingArchivedTasks: false,
  archivedTasksError: null,
  currentPage: 1,
  totalArchivedTasksCount: 0,
};

const mutations = {
  SET_ARCHIVED_TASKS_LIST(state, tasksList) {
    state.archivedTasksList = tasksList;
  },
  SET_PAGINATION(state, { currentPage, totalArchivedTasksCount }) {
    state.currentPage = currentPage;
    state.totalArchivedTasksCount = totalArchivedTasksCount;
  },
  SET_LOADING_ARCHIVED_TASKS(state, isLoading) {
    state.isLoadingArchivedTasks = isLoading;
  },
  SET_ARCHIVED_TASKS_ERROR(state, error) {
    state.archivedTasksError = error;
  },
  SET_ACTIVE_FILTERS(state, filter) {
    state.activeFilters = filter;
  },
};

const actions = {
  async fetchArchivedTasksList({ commit, dispatch, state }) {
    commit('SET_LOADING_ARCHIVED_TASKS', true);
    commit('SET_ARCHIVED_TASKS_ERROR', null);
    commit('SET_ARCHIVED_TASKS_LIST', null);

    try {
      const response = await fetchTasksList({
        userId: state.activeFilters.partner,
        startDate: state.activeFilters.period?.start || null,
        endDate: state.activeFilters.period?.end || null,
        page: state.currentPage,
        perPage: ARCHIVED_TASKS_PER_PAGE_COUNT,
      });

      const currentPage = response?.tasks?.current_page || 1;
      const totalArchivedTasksCount = response?.tasks?.total || 0;

      commit('SET_ARCHIVED_TASKS_LIST', response?.tasks?.data || []);
      commit('SET_PAGINATION', { currentPage, totalArchivedTasksCount });
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити дані з архіву завдань';

      commit('SET_ARCHIVED_TASKS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити архів завдань',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_ARCHIVED_TASKS', false);
    }
  },
  setupFilter: ({ state, commit, dispatch }, filters, mode = 'replace') => {
    if (mode === 'replace') {
      commit('SET_PAGINATION', { currentPage: 1, totalTasksCount: 0 });
      commit('SET_ACTIVE_FILTERS', filters);
    } else {
      commit('SET_PAGINATION', { currentPage: 1, totalTasksCount: 0 });
      commit('SET_ACTIVE_FILTERS', { ...state.activeFilters, ...filters });
    }

    dispatch('fetchArchivedTasksList');
  },
  changePaginatedPage({ state, commit, dispatch }, page) {
    commit('SET_PAGINATION', { currentPage: page, totalTasksCount: state.totalArchivedTasksCount });
    dispatch('fetchArchivedTasksList');
  },
};

const getters = {
  getActiveFilters: (state) => state.activeFilters,

  isLoadingArchivedTasks: (state) => state.isLoadingArchivedTasks,
  archivedTasksError: (state) => state.archivedTasksError,
  isArchivedTasksDataReady: (state) => state.isLoadingArchivedTasks === false && state.archivedTasksList !== null,
  isEmpty: (state) => !state.archivedTasksList || state.archivedTasksList?.length === 0,
  getArchivedTasksList: (state) => state.archivedTasksList,
  getCurrentPage: (state) => state.currentPage || 1,
  getPerPageCount: () => ARCHIVED_TASKS_PER_PAGE_COUNT,
  getArchivedTasksTotalCount: (state) => state.totalArchivedTasksCount || 0,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
